// 中文-简体不需要自定义翻译组件的文案
export default {}
